import React from 'react';

// In-house port of react-sortable 2.0's sortable() HOC, which depended on its own
// copy of React 16. Same props and behavior: rows get HTML5 drag and touch handlers,
// and dragging one past another swaps them in `items` (in place) and hands the
// array to onSortItems.
let draggingIndex = null;

function isMouseBeyond(mousePosition, elementPosition, elementSize, moveInMiddle) {
	const breakPoint = moveInMiddle ? elementSize / 2 : 0;
	return mousePosition - elementPosition > breakPoint;
}

function swapArrayElements(items, indexFrom, indexTo) {
	const item = items[indexTo];
	items[indexTo] = items[indexFrom];
	items[indexFrom] = item;
	return items;
}

export function sortable(Component) {
	function Sortable({ onSortItems, sortId, moveInMiddle = false, ...props }) {
		const sortStart = (event) => {
			draggingIndex = event.currentTarget.dataset.id;
			const dataTransfer = event.dataTransfer;
			if(dataTransfer !== undefined && dataTransfer !== null) {
				dataTransfer.setData('text', event.target.innerHTML);
				// Keeps the dragged <a>'s appearance instead of the browser's link ghost.
				if(dataTransfer.setDragImage && event.currentTarget.tagName.toLowerCase() === 'a') {
					dataTransfer.setDragImage(event.target, 0, 0);
				}
			}
		};

		const sortEnd = (event) => {
			event.preventDefault();
			draggingIndex = null;
		};

		const dragOver = (event) => {
			event.preventDefault();
			const overElement = event.currentTarget;
			const indexDragged = Number(overElement.dataset.id);
			const indexFrom = Number(draggingIndex);
			const { top, height } = overElement.getBoundingClientRect();

			if(indexDragged !== indexFrom && isMouseBeyond(event.clientY, top, height, moveInMiddle)) {
				const items = swapArrayElements(props.items, indexFrom, indexDragged);
				draggingIndex = indexDragged;
				onSortItems(items);
			}
		};

		return (
			<Component
				draggable
				onDragOver={dragOver}
				onDragStart={sortStart}
				onDragEnd={sortEnd}
				onTouchStart={sortStart}
				onTouchMove={dragOver}
				onTouchEnd={sortEnd}
				data-id={sortId}
				moveInMiddle={moveInMiddle}
				{...props}
			/>
		);
	}
	Sortable.displayName = `Sortable(${Component.displayName || Component.name || 'Component'})`;
	return Sortable;
}
